import { render, staticRenderFns } from "./userSelete.vue?vue&type=template&id=2195b412&scoped=true&"
import script from "./userSelete.vue?vue&type=script&lang=js&"
export * from "./userSelete.vue?vue&type=script&lang=js&"
import style0 from "./userSelete.vue?vue&type=style&index=0&id=2195b412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2195b412",
  null
  
)

export default component.exports